import { ApiStage } from '@xylabs/sdk-js'
import { isLocalhost } from '@xylabs/sdk-react'

export interface ApiDomainConfig {
  beta?: string
  local?: string
  prod: string
}

export class ApiDomain {
  config: ApiDomainConfig
  constructor(config: ApiDomainConfig) {
    this.config = config
  }

  get stage() {
    return isLocalhost() ? ApiStage.Local : document.location.hostname.startsWith('beta') ? ApiStage.Beta : ApiStage.Prod
  }

  get url() {
    switch (this.stage) {
      case ApiStage.Local:
        return this.config.local ?? this.config.beta ?? this.config.prod
      case ApiStage.Beta:
        return this.config.beta ?? this.config.prod
      default:
        return this.config.prod
    }
  }
}
